module.exports = __webpack_public_path__ + "static/media/dom7_3.7df18897.jpg";